import { RequestToAssistant, ChatHistory, ChatRole } from './../models/chat.model';
import { BgBomItemDTO, BgBomSubCategory } from './../models/bg.model';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BgBomItem, BgBomModel } from '../models/bg.model';
import { LoginResponseModel } from '../models/loginResponseModel';
import { ServiceResponse } from '../models/serviceResponse.model';
import { GoogleDriveFileInfoDto } from '../models/googleDriveFileInfo.model';
import { AuthService } from './auth.service';
import { EndpointFactory } from './endpoint.service';
import { Client } from './admin-state.service';
import { ItemParameter ,  ItemParameterDTO} from '../models/itemParameter';
import { ClientSupportMessage } from '../models/client-support-message.model';
import { SKIP_LOADING } from '../interceptors/http-context-tokens';
import { OfferGroup } from '../models/commercial-offer.model';
import {
  ContractorInvite,
  CreateRfpRequest,
  Rfp,
  RfpContractorStatus,
  RfpContractorView,
  RfpPreview,
  SubmitProposalRequest,
} from '../models/rfp.model';

// Add this interface for the change password request
export interface ChangePasswordRequest {
  userId: string;
  email: string;
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

// User registration interface
export interface RegisterUserRequest {
  userName?: string;
  password?: string;
  email?: string;
  permissions: string[];
  userRole?: string;
  clientId?: string;
  usersId?: string[];
}

// Update permissions request
export interface UpdatePermissionsRequest {
  usersId: string[];
  permissions: string[];
}

@Injectable({
  providedIn: 'root',
})
export class BackendApiService {
  constructor(
    private http: HttpClient,
    private endpoint: EndpointFactory,
    private authService: AuthService
  ) {}

// this is the  array of the   models  what user is currently working on
  public   CurrentModelsIds: string[] = [];

  // User creation method
  public createUser(user: RegisterUserRequest): Observable<ServiceResponse<any>> {
    return this.http.post<ServiceResponse<any>>(
      this.endpoint.CreateUser,
      user,
      { headers: this.headersWithAuth() }
    );
  }

  public GetModelById(id: string): Observable<ServiceResponse<BgBomModel>> {

    while(this.CurrentModelsIds.length > 0) {
      this.CurrentModelsIds.pop();
      }
    //if contains any model  clear it but not clear  memory
    this.CurrentModelsIds.push(id);

    return this.http
      .get<ServiceResponse<BgBomModel>>(
        this.endpoint.GetBgModelById + '?modelId=' + id,
        { headers: this.headersWithAuth() }
      )
      .pipe(
        map((records) => {
          return records;
        })
      );
  }

    public UpdateBomModel(bgBomSubCategory : BgBomSubCategory , modelId : string ): Observable<any> {
      // Make sure to pass the BgBomModel in the body of the PUT request
      return this.http.patch<any>(
        this.endpoint.PatchBomModelStructure,
        {
             SubCategory: JSON.stringify({
            Name: bgBomSubCategory.name,
            Order: bgBomSubCategory.order,
            BgBomItems: this.mappingBgBomItems(bgBomSubCategory.bgBomItems),
            CombinedBgBomItems: bgBomSubCategory.combinedBgBomItems,

             }),


          ModelId : modelId,
        },
        {
          headers: this.headersWithAuth() ,
          context: new HttpContext().set(SKIP_LOADING, true)
        }
      );
    }


    public uploadFile(file: File): Observable<any> {
      return this.http.post(this.endpoint.UploadFile, file, { headers: this.headersWithAuth() });
    }

    mappingBgBomItems(bgBomItems: BgBomItem[]): BgBomItemDTO[] | undefined {
      if (!bgBomItems || bgBomItems.length === 0) {
        return undefined;
      }

      return bgBomItems.map((item: BgBomItem) => {
        const dto = new BgBomItemDTO();

        dto.id = item.id;
        dto.parentId = item.parentId;
        dto.order = Math.ceil(item.order ?? 0); // only integer values are allowed
        dto.group = item.group;
        dto.itemName = item.itemName;
        dto.size = item.size;
        dto.itemBomType = item.itemBomType;
        dto.material = item.material;
        dto.description = item.description;
        dto.manufacturer = item.manufacturer;
        dto.manufacturerModel = item.manufacturerModel;
        dto.modelQuantity = item.modelQuantity;
        dto.modelQuantityDescription = item.modelQuantityDescription;
        dto.quantity = item.quantity;
        dto.wasteFactor = item.wasteFactor;
        dto.quantityToOrder = item.quantityToOrder;
        dto.quantityToOrderDescription = item.quantityToOrderDescription;
        dto.parameters = item.parameters ? this.mappingBgBomParameters(item.parameters) ?? [] : [];
        dto.cost = item.cost;
        dto.totalCost = item.totalCost;

        return dto;
      });
    }

    mappingBgBomParameters(bgBomParameters: ItemParameter[]): ItemParameterDTO[] | undefined {
      if (!bgBomParameters || bgBomParameters.length === 0) {
        return undefined;
      }

      return bgBomParameters.map((param: ItemParameter) => {
        const dto = new ItemParameterDTO();

        dto.n = param.name;
        dto.d = param.valueDouble;
        dto.s = param.valueString;
        dto.m = param.measurement;

        return dto;
      });
    }


    public AskAiAssistant(
      request: RequestToAssistant
    ): Observable<ServiceResponse<ChatHistory>> {
      return this.http.post<ServiceResponse<ChatHistory>>(
        this.endpoint.AskAiAssistant,
        request,
        { headers: this.headersWithAuth() }
      );
    }





    //convert bomModel to json

  public AddCustomItem(modelId: string, path: string, item: BgBomItem) {
    return this.http.post(
      this.endpoint.AddCustomItem,
      {
        BgBomModelId: modelId,
        Path: path,
        BgBomItem: item,
      },
      {
        headers: this.headersWithAuth(),
        context: new HttpContext().set(SKIP_LOADING, true)
      }
    );
  }

  public DeleteCustomItem(modelId: string, item: BgBomItem) {
    return this.http.delete(this.endpoint.DeleteCustomItem, {
      headers: this.headersWithAuth(),
      context: new HttpContext().set(SKIP_LOADING, true),
      body: {
        BgBomModelId: modelId,
        BgBomItemId: item.id,
      },
    });
  }


  public GetCompareBomModels(ids: string[]): Observable<ServiceResponse<any>> {
    let params = new HttpParams();
    ids.forEach((id) => {
      params = params.append('ids', id);
    });

    return this.http.get<ServiceResponse<any>>(
      this.endpoint.CompareBomModels,
      {
        headers: this.headersWithAuth(),
        params: params,
      }
    );
  }


  public sendSupportMessage(message: string) {
    return this.http.post(
      this.endpoint.SendEmailToSupport,
      { message: message },
      {
        headers: this.headersWithAuth(),
      }
    );
  }

  public sendDemoRequest(email: string) {
    let formData = new FormData();
    formData.append('userEmail', email);

    let headers = new HttpHeaders();
    headers = headers.set('Accept', '*/*');

    return this.http.post(this.endpoint.CreateDemoUser, formData, {
      headers: headers,
    });
  }

  public validateUserId(userId: string) {
    let formData = new FormData();
    formData.append('demoUserId', userId);

    let headers = new HttpHeaders();
    headers = headers.set('Accept', '*/*');

    return this.http.post<LoginResponseModel>(
      this.endpoint.LoginDemoUser,
      formData,
      {
        headers: headers,
      }
    );
  }

  // Add the change password method
  public changePassword(request: ChangePasswordRequest): Observable<ServiceResponse<any>> {
    return this.http.post<ServiceResponse<any>>(
      this.endpoint.ChangePassword,
      request,
      { headers: this.headersWithAuth() }
    );
  }

  public sendClientSupportMessage(message: ClientSupportMessage): Observable<any> {
    return this.http.post(
      this.endpoint.SendClientSupportMessage,
      message
    );
  }

  // Get users for the current client
  public getUsers(): Observable<ServiceResponse<any>> {
    return this.http.get<ServiceResponse<any>>(
      this.endpoint.GetUsers,
      { headers: this.headersWithAuth() }
    );
  }

  // Get all clients for admin users
  public getAllClients(): Observable<ServiceResponse<any>> {
    return this.http.get<ServiceResponse<any>>(
      this.endpoint.GetAllClients,
      { headers: this.headersWithAuth() }
    );
  }

  public getClientById(clientId: string): Observable<ServiceResponse<any>> {
    return this.http.get<ServiceResponse<any>>(
      this.endpoint.GetClient + '/' + clientId,
      { headers: this.headersWithAuth() }
    );
  }

  // Update client (full document replace; API checks Version)
  public updateClient(client: Client): Observable<ServiceResponse<Client>> {
    return this.http.put<ServiceResponse<Client>>(
      this.endpoint.UpdateClient,
      client,
      { headers: this.headersWithAuth() }
    );
  }

  // Delete client document by id
  public deleteClient(clientId: string): Observable<ServiceResponse<boolean>> {
    return this.http.delete<ServiceResponse<boolean>>(
      this.endpoint.DeleteClient,
      {
        headers: this.headersWithAuth(),
        params: new HttpParams().set('clientId', clientId)
      }
    );
  }

  // Get BgModels by client ID
  public getBgModelsByClientId(clientId: string): Observable<ServiceResponse<BgBomModel[]>> {
    return this.http.get<ServiceResponse<BgBomModel[]>>(
      this.endpoint.GetBgModelsByClientId + '?clientId=' + clientId,
      { headers: this.headersWithAuth() }
    );
  }

  // Update user permissions
  public updateUserPermissions(userId: string, permissions: string[]): Observable<ServiceResponse<any>> {
    const request: UpdatePermissionsRequest = {
      usersId: [userId],
      permissions: permissions
    };

    return this.http.patch<ServiceResponse<any>>(
      this.endpoint.UpdateUserPermissions,
      request,
      { headers: this.headersWithAuth() }
    );
  }

  // Delete user
  public deleteUser(userId: string): Observable<ServiceResponse<any>> {
    const request = {
      usersId: [userId]
    };
    return this.http.delete<ServiceResponse<any>>(
      this.endpoint.DeleteUser,
      {
        headers: this.headersWithAuth(),
        body: request
      }
    );
  }

  // RFP
  public getRfpBomForRfp(
    modelId: string
  ): Observable<ServiceResponse<OfferGroup>> {
    const url = this.endpoint.GetRfpBomForRfp.replace(
      ':modelId',
      encodeURIComponent(modelId)
    );

    return this.http.get<ServiceResponse<OfferGroup>>(url, {
      headers: this.headersWithAuth(),
    });
  }

  public createRfp(
    modelId: string,
    request: CreateRfpRequest
  ): Observable<ServiceResponse<Rfp>> {
    const url = this.endpoint.CreateRfp.replace(
      ':modelId',
      encodeURIComponent(modelId)
    );

    return this.http.post<ServiceResponse<Rfp>>(url, request, {
      headers: this.headersWithAuth(),
    });
  }

  public getRfpById(rfpId: string): Observable<ServiceResponse<Rfp>> {
    const url = this.endpoint.GetRfpById.replace(
      ':rfpId',
      encodeURIComponent(rfpId)
    );

    return this.http.get<ServiceResponse<Rfp>>(url, {
      headers: this.headersWithAuth(),
    });
  }

  public getAllRfps(): Observable<ServiceResponse<Rfp[]>> {
    return this.http.get<ServiceResponse<Rfp[]>>(this.endpoint.GetAllRfps, {
      headers: this.headersWithAuth(),
    });
  }

  public getRfpPreviews(): Observable<ServiceResponse<RfpPreview[]>> {
    return this.http.get<ServiceResponse<RfpPreview[]>>(
      this.endpoint.GetRfpPreviews,
      { headers: this.headersWithAuth() }
    );
  }

  public getRfpPreviewsByModelId(modelId: string): Observable<ServiceResponse<RfpPreview[]>> {
    const url = this.endpoint.GetRfpPreviewsByModelId.replace(
      ':modelId',
      encodeURIComponent(modelId)
    );

    return this.http.get<ServiceResponse<RfpPreview[]>>(url, {
      headers: this.headersWithAuth(),
    });
  }

  public updateRfp(
    rfpId: string,
    rfp: Rfp
  ): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.UpdateRfp.replace(
      ':rfpId',
      encodeURIComponent(rfpId)
    );

    return this.http.put<ServiceResponse<boolean>>(url, rfp, {
      headers: this.headersWithAuth(),
    });
  }

  public publishRfp(rfpId: string): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.PublishRfp.replace(
      ':rfpId',
      encodeURIComponent(rfpId)
    );

    return this.http.patch<ServiceResponse<boolean>>(url, null, {
      headers: this.headersWithAuth(),
    });
  }

  public closeRfp(rfpId: string): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.CloseRfp.replace(
      ':rfpId',
      encodeURIComponent(rfpId)
    );

    return this.http.patch<ServiceResponse<boolean>>(url, null, {
      headers: this.headersWithAuth(),
    });
  }

  public deleteRfp(rfpId: string): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.DeleteRfp.replace(
      ':rfpId',
      encodeURIComponent(rfpId)
    );

    return this.http.delete<ServiceResponse<boolean>>(url, {
      headers: this.headersWithAuth(),
    });
  }

  public markRfpAsDeleted(rfpId: string): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.MarkRfpAsDeleted.replace(
      ':rfpId',
      encodeURIComponent(rfpId)
    );

    return this.http.patch<ServiceResponse<boolean>>(url, null, {
      headers: this.headersWithAuth(),
    });
  }

  public inviteContractors(
    rfpId: string,
    invites: ContractorInvite[]
  ): Observable<ServiceResponse<string[]>> {
    const url = this.endpoint.InviteContractors.replace(
      ':rfpId',
      encodeURIComponent(rfpId)
    );

    return this.http.post<ServiceResponse<string[]>>(url, invites, {
      headers: this.headersWithAuth(),
    });
  }

  public selectContractor(
    rfpId: string,
    contractorId: string
  ): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.SelectContractor
      .replace(':rfpId', encodeURIComponent(rfpId))
      .replace(':contractorId', encodeURIComponent(contractorId));

    return this.http.patch<ServiceResponse<boolean>>(url, null, {
      headers: this.headersWithAuth(),
    });
  }

  public getRfpForContractor(
    contractorId: string
  ): Observable<ServiceResponse<RfpContractorView>> {
    const url = this.endpoint.GetRfpForContractor.replace(
      ':contractorId',
      encodeURIComponent(contractorId)
    );

    return this.http.get<ServiceResponse<RfpContractorView>>(url);
  }

  public submitProposal(
    contractorId: string,
    request: SubmitProposalRequest
  ): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.SubmitProposal.replace(
      ':contractorId',
      encodeURIComponent(contractorId)
    );

    return this.http.post<ServiceResponse<boolean>>(url, request);
  }

  public updateProposal(
    contractorId: string,
    request: SubmitProposalRequest
  ): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.UpdateProposal.replace(
      ':contractorId',
      encodeURIComponent(contractorId)
    );

    return this.http.put<ServiceResponse<boolean>>(url, request);
  }

  public declineRfp(
    contractorId: string
  ): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.DeclineRfp.replace(
      ':contractorId',
      encodeURIComponent(contractorId)
    );

    return this.http.patch<ServiceResponse<boolean>>(url, null);
  }

  public updateContractorStatusViewed(
    contractorId: string
  ): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.UpdateContractorStatusViewed.replace(
      ':contractorId',
      encodeURIComponent(contractorId)
    );

    return this.http.patch<ServiceResponse<boolean>>(url, null, {
      context: new HttpContext().set(SKIP_LOADING, true),
    });
  }

  public updateContractorStatus(
    rfpId: string,
    contractorId: string,
    status: RfpContractorStatus
  ): Observable<ServiceResponse<boolean>> {
    const url = this.endpoint.UpdateContractorStatus
      .replace(':rfpId', encodeURIComponent(rfpId))
      .replace(':contractorId', encodeURIComponent(contractorId));
    const params = new HttpParams().set('status', String(status));

    return this.http.patch<ServiceResponse<boolean>>(url, null, {
      headers: this.headersWithAuth(),
      params,
    });
  }

  private headersWithAuth() {
    const token = this.authService.getAuthBearerToken();
    let headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    return headers;
  }

  // Google Drive
  public getGoogleDriveFilesByFolderId(
    folderId: string
  ): Observable<ServiceResponse<GoogleDriveFileInfoDto[]>> {
    const url = this.endpoint.GetGoogleDriveFilesByFolderId.replace(
      ':folderId',
      encodeURIComponent(folderId)
    );

    return this.http.get<ServiceResponse<GoogleDriveFileInfoDto[]>>(url, {
      headers: this.headersWithAuth(),
    });
  }

  /**
   * Converts a Google Drive folder URL to folder id.
   */
  public convertGoogleDriveFolderUrlToId(
    folderUrl: string
  ): Observable<ServiceResponse<string>> {
    const params = new HttpParams().set('folderUrl', folderUrl);

    return this.http.get<ServiceResponse<string>>(
      this.endpoint.ConvertGoogleDriveFolderUrlToId,
      {
        headers: this.headersWithAuth(),
        params,
      }
    );
  }

  /**
   * Downloads a Google Drive file by id.
   * Backend returns a file stream on success (not a ServiceResponse).
   */
  public downloadGoogleDriveFileById(fileId: string): Observable<Blob> {
    const url = this.endpoint.DownloadGoogleDriveFileById.replace(
      ':fileId',
      encodeURIComponent(fileId)
    );

    // Angular typing quirk: responseType 'blob' is incompatible with generic T unless casted.
    return this.http.get(url, {
      headers: this.headersWithAuth(),
      responseType: 'blob',
    });
  }




}
